







































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { VariableValue, Visualization } from '../../../core/models';
import { pluckAndStartWatch } from '../../../core/operators';
import { tap } from 'rxjs/operators';
import VisualizationStore, { VisualizationState } from './visualization.state';
import { isNumber, isPositiveFloatNumber } from '../../../core/utils';
import { PaintingType } from '../../utils';
import Input from '../../../core/components/Input.vue'

@Component<VisualizationForm>({
    components: {
        Input
    },
    subscriptions() {
        return {
            variables$: this.$watchAsObservable('variables', { immediate: true }).pipe(
                pluckAndStartWatch([]),
                tap((variables: VariableValue[]) => this.store.updateVariable(variables[0]))
            ),
            variableSelected$: this.store.variable$,
            paintingType$: this.store.paintingType$,
            min$: this.store.min$,
            max$: this.store.max$,
            workingWidth$: this.store.workingWidth$,
            toneQuantity$: this.store.toneQuantity$,
            unit$: this.store.unit$
        };
    }
})
export default class VisualizationForm extends Vue {
    @Prop({ default: () => () => [] }) variables: VariableValue[];
    paintingTypes: PaintingType[] = [PaintingType.GREEN_RED, PaintingType.RED_GREEN];
    store: VisualizationStore = new VisualizationStore();
    validVisualization: boolean = false;
    minFocus: boolean = true;
    variableSelected$: VariableValue;
    paintingType$: PaintingType;
    min$: string;
    max$: string;
    workingWidth$: string;
    toneQuantity$: string;
    unit$: string;
    validateForm: boolean = false;

    handleVariableSelect(select: VariableValue): void {
        this.store.updateVariable(select);
        this.disableValidationForm();
    }

    handleMin(min: string): void {
        this.store.updateMin(min);
        this.disableValidationForm();
    }

    handleMax(max: string): void {
        this.store.updateMax(max);
        this.disableValidationForm();
    }

    handleWorkingWidth(workingWidth: string): void {
        this.store.updateWorkingWidth(workingWidth);
        this.disableValidationForm();
    }

    handleToneQuantity(toneQuantity: string): void {
        this.store.updateToneQuantity(toneQuantity);
        this.disableValidationForm();
    }

    handlePaintingTypeSelect(select: PaintingType): void {
        this.store.updatePaintingType(select);
        this.disableValidationForm();
    }

    isMaxGreaterThan(max: string): boolean {
        return +this.min$ < +max;
    }

    get form(): HTMLFormElement {
        return this.$refs.form as HTMLFormElement;
    }

    validate(): Promise<boolean> {
        this.validateForm = true;
        return this.$nextTick().then(() => this.form.validate());
    }
    reset() {
        this.form.reset();
    }
    resetValidation() {
        this.disableValidationForm();
        this.form.resetValidation();
    }

    disableValidationForm(): void {
        this.validateForm = false;
    }

    getState(): VisualizationState {
        return this.store.selectSnapshot<VisualizationState>(store => store);
    }

    getVisualization(): Visualization | null {
        const state = this.getState();
        return state.visualization;
    }

    clearState() {
        this.store.reset();
    }

    updateVisualization(visualization: Visualization): void {
        this.store.updateVisualization(visualization);
    }

    get minRules(): any[] {
        return this.validateForm
            ? [v => !!v || 'valor requerido', v => isNumber(v) || 'valor inválido']
            : [];
    }

    get maxRules(): any[] {
        return this.validateForm
            ? [
                  v => !!v || 'valor requerido',
                  v => isNumber(v) || 'valor inválido',
                  v => this.isMaxGreaterThan(v) || 'no puede ser menor que el valor mínimo'
              ]
            : [];
    }

    get workingWidthRules(): any[] {
        return this.validateForm
            ? [v => !!v || 'valor requerido', v => isPositiveFloatNumber(v) || 'valor inválido']
            : [];
    }

    get toneQuantityRules(): any[] {
        return this.validateForm
            ? [
                  v => !!v || 'valor requerido',
                  v => isPositiveFloatNumber(v) || 'valor inválido',
                  v => v <= 10 || 'no puede ser mayor de 10'
              ]
            : [];
    }
}
